import {
  FC,
  useMemo,
  useRef,
  useState,
  useEffect,
} from "react";
import { Tag } from "@brg/api";
import { BTag } from "core/components";
import { bTag } from "../../../core";
import { FlexBox } from "@brg/ui";
import { LayoutConst } from "core/modules";
import {
  TagsSearchResults,
  TagsSearchResultsContext
} from "./styles";
import styled, { useTheme } from "styled-components";
import { LOAD_TYPE } from "./selectTagsModal";
import { useTranslation } from "react-i18next";
import FoundChildrens from "./FoundedChildrens";
import { ITagsProps } from "shared/hooks/api/useTagsList";
import { isRequired } from "./support/isRequired";
import ReactTooltip from "react-tooltip";
import { getTooltipStyles } from "shared/constants/tooptipStyles";
import { AppTester } from "supporting";
import { CreateTagButton } from "./components/CreateTagComponent/style";
import { CreateTagComponent } from "./components/CreateTagComponent/CreateTagComponent";
import {BTagsGridNew} from "../../../core/components/bTag/bTagsGridNew/bTagsGridNew";

/**
 * @deprecated
 */

export const EmptyTextWrapper = styled(FlexBox)<{ isMobileMenu?: boolean, isIqMediia?: boolean}>`
  position: absolute;
  top: ${({ isIqMediia }) => isIqMediia ? '30%' : '60%'};
  left: 0;
  z-index: 99;
  transform: translateY(-60%);
  @media (max-width: ${LayoutConst.screen.sm}px) {
    top: ${({ isMobileMenu }) => isMobileMenu? '70%' : '61.4%'};
    height: 75.3%;
    background: ${({ theme }) => theme.tags.modal.searchResult.bg};
    opacity: 0.47;
    border-radius: 8px;
    left: 10px;
    width: 95%;
  }
`;

export const EmptyText = styled.div`
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 22px;
  line-height: 26px;
  letter-spacing: -0.02em;
  color: ${(p) => p?.theme.tags.emptySearchColor};
  @media (max-width: ${LayoutConst.screen.sm}px) {
    max-width: 150px;
    font-size: 17px;
    line-height: 22px;
    text-align: center;
  }
`;

export enum TAGS_LEVEL {
  child = 0,
  children = 1,
  parent = 2,
}

export interface TagsSearchResultsItemProps {
  searchingIntoTag?: boolean;
  isSelected: (id: string) => boolean;
  onClick: (tag: Tag, selected: boolean) => void;
  onParentClick?: (id: string) => void;
  onMoreClick?: (id: string, loadT?: number) => void;
  onTagArrowClick?: (id: string, loadT: number) => void;
  onMoreLargeCategoryClick?: (id: string, loadT: number) => void;
  onSearchInputChange?: (e: any, id: string, loadT?: number) => void;
  onSearchIntoCategory?: (e: any, id: string, loadT?: number) => void;
  isTagOpen?: boolean;
  setIsOpenTag?: Function;
  searchText: string;
  moreNeeded?: boolean;
  searchNeeded?: boolean;
  tagsFilter?: ITagsProps;
  isGlobalSearch?: boolean;
  isProjectEdit?: boolean;
}

export interface IGrouppedTags<T> {
  isEducationTag?: boolean;
  categoryId?: string;
  childrens?: T;
  found?: number;
  position?: number;
  groupId?: string | null;
  categoryTitle?: string;
  isTagCategory?: boolean;
  isSearchButton?: boolean;
  isMoreButton?: boolean;
}

interface IProps {
  items: IGrouppedTags<Tag[]>[];
  onClick: (tag: Tag) => void;
  isSelected: (id: string) => boolean;
  onAfterTagCreate?: () => void;
  visible?: boolean;
  isOpen?: boolean;
  setIsOpen?: Function;
  isLargeCategoryOpen?: boolean;
  isChildrensOpen?: boolean;
  loadType: number;
  isEmptySearch?: boolean;
  showEmptyMsg?: boolean;
  requiredTags?: string[];
  showEducationCategoryTags?: boolean;
  viewAllTags?: boolean;
  isTagAdminPage?: boolean;
  isLinkMode?: boolean;
  isLoading?: boolean;
}

const FoundTags: FC<IProps & TagsSearchResultsItemProps> = ({
  items,
  onClick,
  isSelected,
  searchText,
  setIsOpenTag,
  isEmptySearch,
  onParentClick,
  onMoreClick,
  onAfterTagCreate,
  onSearchInputChange,
  tagsFilter,
  showEmptyMsg,
  isGlobalSearch,
  isProjectEdit,
  requiredTags,
  viewAllTags,
  isTagAdminPage,
  showEducationCategoryTags,
  isLinkMode,
  isLoading,
}) => {
  const activeTag = useRef<any>(null);
  const { t } = useTranslation();
  const [isCreateMode, setIsCreateMode] = useState(false);
  const [time, setTime] = useState(Date.now());
  const isIqMediia = AppTester.isIqMediiia();
  const theme = useTheme();

  const needDescrSection = useMemo(
    () =>
      items &&
      items?.find((i: any) => i?.isSearchResult),
    [items, searchText]
  );

  useEffect(() => {
    if (activeTag && activeTag.current) {
      activeTag.current = null;
    }
  }, [searchText, activeTag]);

  useEffect(() => {
    setIsCreateMode(false);
  }, [])

  //Костыль чтобы убрать образовательную категорию и образов теги взависимости от открытой модалки
  const getExcludesEdicationTags = (arr: any[]) => {
    if (isGlobalSearch && isProjectEdit) {
      return arr?.filter((i) => showEducationCategoryTags ? i?.isEducationTag : !i?.isEducationTag)
    }
    return arr;
  }

    const tags = useMemo(() => {
      let baseTags: any = [];
      let levelOneTags: any = [];

      items?.forEach(async(i) => {
        if (i.childrens?.length) {
          baseTags = [...baseTags, ...i.childrens]
        }
      });
      baseTags.forEach(async(i: any) => {
        if (i?.level === TAGS_LEVEL.children) {
          levelOneTags = [...levelOneTags, ...i.additionalTags]
        }
      })

      return [...levelOneTags, ...baseTags]?.toSorted((a,b) => {
        if (!!a.isEducationTag || a.level === TAGS_LEVEL.children) {
          return -1;
        }
        return 0
      })
    } ,[items])

    const foundedTags = useMemo(() => {

      return (
        <BTagsGridNew>
          {getExcludesEdicationTags(tags)?.map((v: any) => {
            const tagHaveChilds = v?.level === 1;
            const isTagSelected = isSelected(v?.tagId);
            const isCanAddNewTag =
              isEmptySearch && v?.typeCategory === "open";
  
            const isOpenTag = v?.tagId === activeTag.current;
  
            const isTagsShadow =
              !isOpenTag &&
              activeTag.current !== null &&
              activeTag.current !== v.tagId;
  
            return (
              <>
                {tagHaveChilds ? (
                  <FoundChildrens
                    item={v}
                    search={searchText}
                    selected={isSelected}
                    parent={true}
                    children_item={v?.additionalTags}
                    onClick={onClick}
                    onParentClick={() => {
                      onParentClick && onParentClick(v?.tagId);
                      setIsOpenTag && setIsOpenTag(!v?.isChildrenVisible);
                    }}
                    onMoreClick={() => {
                      onMoreClick &&
                        onMoreClick(v?.tagId, LOAD_TYPE.tagSearch);
                    }}
                    onTagArrowClick={() => {
                      if(activeTag.current === v.tagId) {
                        activeTag.current = null;
                      } else {
                        activeTag.current = v?.tagId;
                      }
                      setTime(Date.now())
                    }}
                    onSearchInputChange={(e) => {
                      onSearchInputChange &&
                        onSearchInputChange(e, v?.tagId, LOAD_TYPE.tagSearch);
                    }}
                    key={v?.tagId}
                    isEmptySearch={isCanAddNewTag} // признак для добавления тега
                    canOpenTag={isOpenTag}
                    opacity={isTagsShadow}         
                    moreNeeded={v?.isMoreButton}
                    tagsFilter={tagsFilter}
                    isLinkMode={isLinkMode}
                  />
                ) : (
                  <BTag
                    tag={v}
                    removable={isTagSelected}
                    selected={isTagSelected}
                    educational={isRequired(v, requiredTags)}
                    organization={v?.isTeamTag}
                    onClick={() => {
                      onClick(v, isTagSelected);
                    }}
                    isProjectsTag
                    key={v?.tagId}
                    opacity={isTagsShadow}
                    isRequired={isRequired(v, requiredTags, true)}
                    hasLink={isLinkMode}
                  >
                    {bTag.title(v)}
                  </BTag>
                )}
              </>
            );
          })}
      </BTagsGridNew>
      )
    } , [tags, isLoading, activeTag.current, activeTag, time])
  
  const noChildren = !!items?.length && tags?.length === 0;

  if (isCreateMode) {
    return (
      <CreateTagComponent 
        onClose={() => setIsCreateMode(false)} 
        onCreateTag={onAfterTagCreate} 
      />
    )
  }

  if (((noChildren && !needDescrSection) || showEmptyMsg) && !isCreateMode) {

    return (
      <EmptyTextWrapper direction="column" gy={24} isIqMediia={isIqMediia} width="100vw" align="center" justify="center">
        <EmptyText>{t("tags_modal.empty_search_select_from_list")}</EmptyText>
        {(isTagAdminPage || viewAllTags) && <CreateTagButton onClick={() => setIsCreateMode(true)}>{t("tags_modal.create_tag")}</CreateTagButton>}
      </EmptyTextWrapper>
    );
  }

  return (
    <TagsSearchResults
      // offsetTop={15}
      direction={"column"}
      directionMobile={"column"}
      width={"100%"}
    >
      <TagsSearchResultsContext
        direction="column"
        isGlobalSearch={isGlobalSearch}
      >       
        {foundedTags}
        <ReactTooltip {...getTooltipStyles(theme)} />
      </TagsSearchResultsContext>
    </TagsSearchResults>
  );
};

export default FoundTags;
import {
  FC,
  useMemo,
  useRef,
  useState,
  useEffect,
} from "react";
import { Tag } from "@brg/api";
import { BTag } from "core/components";
import { bTag } from "../../../core";
import { FlexBox } from "@brg/ui";
import { LayoutConst } from "core/modules";
import {
  TagsSearchResults,
  TagsSearchResultsContext
} from "./styles";
import styled, { useTheme } from "styled-components";
import { LOAD_TYPE } from "./selectTagsModal";
import { useTranslation } from "react-i18next";
import FoundChildrens from "./FoundedChildrens";
import { ITagsProps } from "shared/hooks/api/useTagsList";
import { isRequired } from "./support/isRequired";
import ReactTooltip from "react-tooltip";
import { getTooltipStyles } from "shared/constants/tooptipStyles";
import { AppTester } from "supporting";
import { CreateTagButton } from "./components/CreateTagComponent/style";
import { CreateTagComponent } from "./components/CreateTagComponent/CreateTagComponent";
import {BTagsGridNew} from "../../../core/components/bTag/bTagsGridNew/bTagsGridNew";

/**
 * @deprecated
 */

export const EmptyTextWrapper = styled(FlexBox)<{ isMobileMenu?: boolean, isIqMediia?: boolean}>`
  position: absolute;
  top: ${({ isIqMediia }) => isIqMediia ? '30%' : '60%'};
  left: 0;
  z-index: 99;
  transform: translateY(-60%);
  @media (max-width: ${LayoutConst.screen.sm}px) {
    top: ${({ isMobileMenu }) => isMobileMenu? '70%' : '61.4%'};
    height: 75.3%;
    background: ${({ theme }) => theme.tags.modal.searchResult.bg};
    opacity: 0.47;
    border-radius: 8px;
    left: 10px;
    width: 95%;
  }
`;

export const EmptyText = styled.div`
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 22px;
  line-height: 26px;
  letter-spacing: -0.02em;
  color: ${(p) => p?.theme.tags.emptySearchColor};
  @media (max-width: ${LayoutConst.screen.sm}px) {
    max-width: 150px;
    font-size: 17px;
    line-height: 22px;
    text-align: center;
  }
`;

export enum TAGS_LEVEL {
  child = 0,
  children = 1,
  parent = 2,
}

export interface TagsSearchResultsItemProps {
  searchingIntoTag?: boolean;
  isSelected: (id: string) => boolean;
  onClick: (tag: Tag, selected: boolean) => void;
  onParentClick?: (id: string) => void;
  onMoreClick?: (id: string, loadT?: number) => void;
  onTagArrowClick?: (id: string, loadT: number) => void;
  onMoreLargeCategoryClick?: (id: string, loadT: number) => void;
  onSearchInputChange?: (e: any, id: string, loadT?: number) => void;
  onSearchIntoCategory?: (e: any, id: string, loadT?: number) => void;
  isTagOpen?: boolean;
  setIsOpenTag?: Function;
  searchText: string;
  moreNeeded?: boolean;
  searchNeeded?: boolean;
  tagsFilter?: ITagsProps;
  isGlobalSearch?: boolean;
  isProjectEdit?: boolean;
}

export interface IGrouppedTags<T> {
  isEducationTag?: boolean;
  categoryId?: string;
  childrens?: T;
  found?: number;
  position?: number;
  groupId?: string | null;
  categoryTitle?: string;
  isTagCategory?: boolean;
  isSearchButton?: boolean;
  isMoreButton?: boolean;
}

interface IProps {
  items: IGrouppedTags<Tag[]>[];
  onClick: (tag: Tag) => void;
  isSelected: (id: string) => boolean;
  onAfterTagCreate?: () => void;
  visible?: boolean;
  isOpen?: boolean;
  setIsOpen?: Function;
  isLargeCategoryOpen?: boolean;
  isChildrensOpen?: boolean;
  loadType: number;
  isEmptySearch?: boolean;
  showEmptyMsg?: boolean;
  requiredTags?: string[];
  showEducationCategoryTags?: boolean;
  viewAllTags?: boolean;
  isTagAdminPage?: boolean;
  isLinkMode?: boolean;
  isLoading?: boolean;
}

const FoundTags: FC<IProps & TagsSearchResultsItemProps> = ({
  items,
  onClick,
  isSelected,
  searchText,
  setIsOpenTag,
  isEmptySearch,
  onParentClick,
  onMoreClick,
  onAfterTagCreate,
  onSearchInputChange,
  tagsFilter,
  showEmptyMsg,
  isGlobalSearch,
  isProjectEdit,
  requiredTags,
  viewAllTags,
  isTagAdminPage,
  showEducationCategoryTags,
  isLinkMode,
  isLoading,
}) => {
  const activeTag = useRef<any>(null);
  const { t } = useTranslation();
  const [isCreateMode, setIsCreateMode] = useState(false);
  const [time, setTime] = useState(Date.now());
  const isIqMediia = AppTester.isIqMediiia();
  const theme = useTheme();

  const needDescrSection = useMemo(
    () =>
      items &&
      items?.find((i: any) => i?.isSearchResult),
    [items, searchText]
  );

  useEffect(() => {
    if (activeTag && activeTag.current) {
      activeTag.current = null;
    }
  }, [searchText, activeTag]);

  useEffect(() => {
    setIsCreateMode(false);
  }, [])

  //Костыль чтобы убрать образовательную категорию и образов теги взависимости от открытой модалки
  const getExcludesEdicationTags = (arr: any[]) => {
    if (isGlobalSearch && isProjectEdit) {
      return arr?.filter((i) => showEducationCategoryTags ? i?.isEducationTag : !i?.isEducationTag)
    }
    return arr;
  }

    const tags = useMemo(() => {
      let baseTags: any = [];
      let levelOneTags: any = [];

      items?.forEach(async(i) => {
        if (i.childrens?.length) {
          baseTags = [...baseTags, ...i.childrens]
        }
      });
      baseTags.forEach(async(i: any) => {
        if (i?.level === TAGS_LEVEL.children) {
          levelOneTags = [...levelOneTags, ...i.additionalTags]
        }
      })

      return [...levelOneTags, ...baseTags]?.toSorted((a,b) => {
        if (!!a.isEducationTag || a.level === TAGS_LEVEL.children) {
          return -1;
        }
        return 0
      })
    } ,[items])

    const foundedTags = useMemo(() => {

      return (
        <BTagsGridNew>
          {getExcludesEdicationTags(tags)?.map((v: any) => {
            const tagHaveChilds = v?.level === 1;
            const isTagSelected = isSelected(v?.tagId);
            const isCanAddNewTag =
              isEmptySearch && v?.typeCategory === "open";
  
            const isOpenTag = v?.tagId === activeTag.current;
  
            const isTagsShadow =
              !isOpenTag &&
              activeTag.current !== null &&
              activeTag.current !== v.tagId;
  
            return (
              <>
                {tagHaveChilds ? (
                  <FoundChildrens
                    item={v}
                    search={searchText}
                    selected={isSelected}
                    parent={true}
                    children_item={v?.additionalTags}
                    onClick={onClick}
                    onParentClick={() => {
                      onParentClick && onParentClick(v?.tagId);
                      setIsOpenTag && setIsOpenTag(!v?.isChildrenVisible);
                    }}
                    onMoreClick={() => {
                      onMoreClick &&
                        onMoreClick(v?.tagId, LOAD_TYPE.tagSearch);
                    }}
                    onTagArrowClick={() => {
                      if(activeTag.current === v.tagId) {
                        activeTag.current = null;
                      } else {
                        activeTag.current = v?.tagId;
                      }
                      setTime(Date.now())
                    }}
                    onSearchInputChange={(e) => {
                      onSearchInputChange &&
                        onSearchInputChange(e, v?.tagId, LOAD_TYPE.tagSearch);
                    }}
                    key={v?.tagId}
                    isEmptySearch={isCanAddNewTag} // признак для добавления тега
                    canOpenTag={isOpenTag}
                    opacity={isTagsShadow}         
                    moreNeeded={v?.isMoreButton}
                    tagsFilter={tagsFilter}
                    isLinkMode={isLinkMode}
                  />
                ) : (
                  <BTag
                    tag={v}
                    removable={isTagSelected}
                    selected={isTagSelected}
                    educational={isRequired(v, requiredTags)}
                    organization={v?.isTeamTag}
                    onClick={() => {
                      onClick(v, isTagSelected);
                    }}
                    isProjectsTag
                    key={v?.tagId}
                    opacity={isTagsShadow}
                    isRequired={isRequired(v, requiredTags, true)}
                    hasLink={isLinkMode}
                  >
                    {bTag.title(v)}
                  </BTag>
                )}
              </>
            );
          })}
      </BTagsGridNew>
      )
    } , [tags, isLoading, activeTag.current, activeTag, time])
  
  const noChildren = !!items?.length && tags?.length === 0;

  if (isCreateMode) {
    return (
      <CreateTagComponent 
        onClose={() => setIsCreateMode(false)} 
        onCreateTag={onAfterTagCreate} 
      />
    )
  }

  if (((noChildren && !needDescrSection) || showEmptyMsg) && !isCreateMode) {

    return (
      <EmptyTextWrapper direction="column" gy={24} isIqMediia={isIqMediia} width="100vw" align="center" justify="center">
        <EmptyText>{t("tags_modal.empty_search_select_from_list")}</EmptyText>
        {(isTagAdminPage || viewAllTags) && <CreateTagButton onClick={() => setIsCreateMode(true)}>{t("tags_modal.create_tag")}</CreateTagButton>}
      </EmptyTextWrapper>
    );
  }

  return (
    <TagsSearchResults
      // offsetTop={15}
      direction={"column"}
      directionMobile={"column"}
      width={"100%"}
    >
      <TagsSearchResultsContext
        direction="column"
        isGlobalSearch={isGlobalSearch}
      >       
        {foundedTags}
        <ReactTooltip {...getTooltipStyles(theme)} />
      </TagsSearchResultsContext>
    </TagsSearchResults>
  );
};

export default FoundTags;
